lmApp
  .service('StatisticsService', ['$q', '$timeout',
    function ($q, $timeout) {
      var service = {};

      service.GetReportsList = function () {
        var deferred = $q.defer();

        $timeout(function () {
          deferred.resolve([
            {
              title: 'Active subscribers',
              type: 'active-subscriber-stat',
              error: 'Waiting for OSS/BSS gateway setup transaction'
            },
            {
              title: 'Total subscribers',
              type: 'subs-total',
              error: 'Waiting for OSS/BSS gateway setup transaction'
            },
            {
              title: 'Total devices',
              type: 'devices-total',
              error: 'Waiting for OSS/BSS gateway setup transaction'
            },
            {
              title: 'Packages purchase',
              type: 'packages-purchases',
              error: 'Insufficient data for report'
            },
            //{
            //  title: 'Content purchase (TVOD, SVOD)',
            //  type: 'content-purchases',
            //  error: 'Insufficient data for report'
            //},
            {
              title: 'Content usage (last month)',
              type: 'content-usage',
              error: 'Insufficient data for report'
            },
            {
              title: 'Total active VOD items',
              type: 'total-vod',
              error: 'Insufficient data for report'
            },
            {
              title: 'Total active Channels items',
              type: 'total-live',
              error: 'Insufficient data for report'
            },
            {
              title: 'Subscribers segmentation by tariff plans',
              error: 'Insufficient data for report'
            },
            {
              title: 'Subscribers segmentation by usage',
              error: 'Insufficient data for report'
            },
            {
              title: 'Churn and related events (new users, cancelled, suspended, y/q/m)',
              error: 'Insufficient data for report'
            },
            {
              title: 'Revenue by services (live, VOD, VAS)',
              error: 'Insufficient data for report'
            },
            {
              title: 'ARPU Segmentation per tariff package',
              error: 'Insufficient data for report'
            },
            {
              title: 'Average revenue per LivePackage',
              error: 'Insufficient data for report'
            },
            {
              title: 'Average revenue per LiveChannel',
              error: 'Insufficient data for report'
            },
            {
              title: 'Coverage of service (towns, population, consumption patterns)',
              error: 'Insufficient data for report'
            },
            {
              title: 'QOS (average bitrates, channel change, errors, DoS)',
              error: 'Insufficient data for report'
            },
            {
              title: 'Advertising efficiency (CTR, revenue, click volumes)',
              error: 'Insufficient data for report'
            }
          ]);
        }, 1000);

        return deferred.promise;
      };

      service.GetTopContent = function (options) {
        var deferred = $q.defer();

        var url = 'collection/vod.view.month.stat/query';

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetHistory = function (options) {
        var deferred = $q.defer();

        var url = 'collection/history.record/query';

        if (options.start && options.end) url += '/dimension/timestamp/span/' + options.start.unix() + ',' + options.end.unix();
        if (options.start && !options.end) url += '/dimension/timestamp/span/' + options.start.unix();
        if (_.isFinite(options.offset) && options.limit) url += '/enum/' + options.offset + ',' + options.limit;
        if (options.subscriber) url += '/dimension/subscriber_id/eq/' + options.subscriber;
        if (options.enum) url += '/enum/' + options.enum.join(',');

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetDeviceStat = function (options) {
        var deferred = $q.defer();

        var url = 'collection/subscriber.device.stat/query';

        if (options.start && options.end) url += '/dimension/date/span/' + options.start + ',' + options.end;

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      //Deprecate
      service.GetSubscriberStat = function (opt) {
        var deferred = $q.defer();

        var url = 'collection/subscriber.stat/query';

        if (!_.isEmpty(opt)) {
          url += '/dimension/date/span/' + opt.start + ',' + opt.end
        }

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetActiveSubscriberStat = function (opt) {
        if (!opt) opt = {};

        var deferred = $q.defer();

        var url = 'collection/active.subscriber.stat/query';

        if (!_.isEmpty(opt)) {
          url += '/dimension/date/span/' + opt.start + ',' + opt.end
        }

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetPackagesUsage = function (opt) {
        if (!opt) opt = {};

        var deferred = $q.defer();

        var url = '/collection/packages.usage.stat/query';

        if (!_.isEmpty(opt)) {
          url += '/dimension/date/span/' + opt.start + ',' + opt.end
        }

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.ActiveAssetStat = function (opt) {
        if (!opt) opt = {};

        var deferred = $q.defer();

        var url = 'collection/active.asset.stat/query';

        if (!_.isEmpty(opt)) {
          if (opt.type) {
            url += '/dimension/type/eq/' + opt.type;
          }

          url += '/dimension/date/span/' + opt.start + ',' + opt.end
        }

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          })
          .catch(function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      return service;
    }
  ]);
